module.exports = __webpack_public_path__ + "static/media/social.2a4aa84d.jpg";